import React from "react"
import { RiFileExcel2Fill } from "react-icons/ri"
import { type Props } from "./_types"
const IconExcel: React.FC<Props> = ({ size = 15, color = "#fff" }): React.ReactElement => {
  return <RiFileExcel2Fill size={size} color={color} />
}

export default IconExcel
